const textToHash = (text) => {
	let hash = 5381;
	for (let i = 0; i < text.length; i++) {
		hash = (hash * 33) ^ text.charCodeAt(i);
	}
	return hash >>> 0; // Convert to unsigned 32-bit integer
};

export { textToHash }


// WEBPACK FOOTER //
// ./src/helpers/datatype_helpers.js